import { useMutation, useQueryClient } from '@tanstack/react-query';

import { rejectProjectRequest } from '@/api/v4/request-project.api';
import { QueryKey } from '@/config/query-client';
import { notify } from '@/ui/snackbar/notify';
import { useTranslation } from 'react-i18next';

export const useRejectProjectRequest = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('request-project');

  return useMutation({
    mutationFn: rejectProjectRequest,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.PendingProjectRequests],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.PendingProjectRequestsCount],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivities],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivitiesCount],
      });

      notify({
        message: t`rejectModal.success`,
      });
    },
    onError: error => {
      console.error('Failed to reject project request:', error);

      notify({
        message: t`rejectModal.error`,
      });
    },
  });
};
